/**
 * Tiny indirection over `window.location.reload()` so tests can mock
 * the reload behavior without fighting jsdom's non-configurable
 * `location.reload` property descriptor.
 *
 * Production behavior is identical to calling `window.location.reload()`
 * directly — this exists purely as a `vi.spyOn` seam. Pattern used by
 * the wider Vitest ecosystem for the same jsdom limitation.
 *
 * Callers should import the named export and invoke `reloadPage()`;
 * tests then do `vi.spyOn(reloadModule, 'reloadPage')` on the
 * namespace import to substitute a mock without touching `window`.
 */
export function reloadPage(): void {
  window.location.reload();
}
